var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobil-top"},[_c('meta',{attrs:{"name":"viewport","content":"maximum-scale=1.0,minimum-scale=1.0,user-scalable=no,width=device-width,initial-scale=1.0"}}),_vm._v(" "),(_vm.logo)?_c('img',{staticClass:"logo",attrs:{"src":_vm.logo}}):_vm._e(),_vm._v(" "),(_vm.proName)?_c('span',[_vm._v(_vm._s(_vm.proName))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c5ff863","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/train/top.vue
// module id = null
// module chunks = 